import Vue from "vue";
import { webRestService } from "@/main";
export default Vue.extend({
    mounted() {
        webRestService.setAuth(this.$route.query.auth);
        this.$router.push("/admin/management");
    },
});
